import { render, staticRenderFns } from "./ImportDataDialog.vue?vue&type=template&id=0f4567a5&scoped=true"
import script from "./ImportDataDialog.vue?vue&type=script&lang=js"
export * from "./ImportDataDialog.vue?vue&type=script&lang=js"
import style0 from "./ImportDataDialog.vue?vue&type=style&index=0&id=0f4567a5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f4567a5",
  null
  
)

export default component.exports